
<template>
    <div class="file-upload">
        <input type="file" :name="name" @change="handleFileUploadChange" :accept="acceptTypes" />
        <Button class="p-button-secondary" v-if="showRemoveButton" icon="pi pi-times" aria-label="Fjern fil" rounded
            @click="(e) => handleClearFileClick(e)"></Button>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Toast from 'primevue/toast';
export default {
    name: "fileUpload",
    props: ['name', 'sizeLimit', 'acceptTypes', 'showRemoveButton'],
    components: {
        Button,
        Toast,
    },
    data() {
        return {
            dictionary: [],
            model: {
                HasFile: false,
            }
        };
    },
    created() {
        fetch('/umbraco/api/resourcesApi/GetFileUploadDictionary').then((response) => response.json())
            .then((data) => {
                this.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

    },
    methods: {
        handleFileUploadChange(e) {
            this.$emit("fileChange", this.validateFile(e));
        },
        handleClearFileClick(e) {
            let button = e.target;
            if (button.nodeName.toLowerCase() != 'button') {
                button = button.closest('button');
            }

            button.previousElementSibling.value = '';
        },
        validateFile(event) {
            const vm = this;
            let hasErrors = false;

            const file = event.target.files[0];
            if (file) {
                if (!vm.acceptTypes.toLowerCase().includes(file.type.toLowerCase())) {
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.FileUploadWrongTypeErrorNotificationTitle, detail: vm.dictionary.FileUploadWrongTypeErrorNotificationText, life: 10000 });
                    hasErrors = true;
                }

                if (vm.sizeLimit && file.size > vm.sizeLimit) {
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.FileUploadSizeLimitErrorNotificationTitle, detail: vm.dictionary.FileUploadSizeLimitErrorNotificationText, life: 10000 });
                    hasErrors = true;
                }

                if (hasErrors) {
                    event.target.value = "";
                }
            } else {
                vm.$toast.add({ severity: 'error', summary: vm.dictionary.FileUploadNoFileErrorNotificationTitle, detail: vm.dictionary.FileUploadNoFileErrorNotificationText, life: 10000 });
                hasErrors = true;
            }

            return !hasErrors;
        }
    }
};
</script>